var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-entry"},[_c('img',{staticClass:"pdf-img",attrs:{"src":require("@/assets/images/pdf.png"),"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.t('该内容为独立文件')))]),_c('span',{staticClass:"file",on:{"click":_vm.goPage}},[_vm._v(_vm._s(_vm.t('打开文件'))),_c('i',{staticClass:"iconfont icon-gengduo"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }